export default "__VITE_ASSET__zNuf72_H__"